import { render, staticRenderFns } from "./loosebeads.vue?vue&type=template&id=9b85c1e6&scoped=true&"
import script from "./loosebeads.vue?vue&type=script&lang=js&"
export * from "./loosebeads.vue?vue&type=script&lang=js&"
import style0 from "./loosebeads.vue?vue&type=style&index=0&id=9b85c1e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b85c1e6",
  null
  
)

export default component.exports